import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { RuleMessage } from '../models/rule-message.model';
import { AddRuleMessageRequest } from '../models/requests/add-rule-message.request';
import { UpdateRuleMessageRequest } from '../models/requests/update-rule-message.request';
import {
  RuleMessageRequest,
  RuleMessageResponse,
} from '../models/requests/rule-message.request';
import { JournalDigestRequest } from '../models/requests/journal-digest.request';
import { JournalDigestDayGroup } from '../models/journal-digest.model';

@Injectable({
  providedIn: 'root',
})
export class RuleMessageService {
  constructor(private apiService: ApiService) {}

  public GetByRuleId(
    request: RuleMessageRequest,
  ): Observable<RuleMessageResponse> {
    return this.apiService.post<RuleMessageResponse>(
      '/RuleMessage/GetByRuleId',
      request,
    );
  }

  public Add(request: AddRuleMessageRequest): Observable<RuleMessage> {
    return this.apiService.post<RuleMessage>('/RuleMessage/Add', request);
  }

  public Update(request: UpdateRuleMessageRequest): Observable<RuleMessage> {
    return this.apiService.put<RuleMessage>('/RuleMessage/Update', request);
  }

  public GetJournalDigest(
    request: JournalDigestRequest,
  ): Observable<JournalDigestDayGroup[]> {
    return this.apiService.post<JournalDigestDayGroup[]>(
      '/RuleMessage/GetJournalDigest',
      request,
    );
  }
}
